import { useCallback, useEffect, useState } from "react";

import { Delete as DeleteIcon } from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PermissionEnum } from "@/features/permissions";
import {
  AddSalesOrderDefaultGeneralProductVariantFormDialog,
  DeleteConfirmationDialog,
} from "@/features/sales-order-default-general-product-variants";
import { apiClient } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

export const SalesOrderDefaultGeneralProductVariants = () => {
  const { hasPermission } = useAuth();
  const { showSnackbar } = useSnackbar();
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [deleteConfirmationDialogOpen, setDeleteConfirmationDialogOpen] =
    useState(false);
  const [
    salesOrderDefaultGeneralProductVariants,
    setSalesOrderDefaultGeneralProductVariants,
  ] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadSalesOrderDefaultGeneralProductVariants = useCallback(async () => {
    setLoading(true);
    try {
      const {
        data: { data },
      } = await apiClient.get("/sales-order-default-general-product-variants");

      setSalesOrderDefaultGeneralProductVariants(data);
    } catch (error) {
      showSnackbar(`Gagal memuat variabel produk umum penjualan ${error}`);
    } finally {
      setLoading(false);
    }
  }, [showSnackbar]);

  useEffect(() => {
    loadSalesOrderDefaultGeneralProductVariants();
  }, [loadSalesOrderDefaultGeneralProductVariants]);

  const toolbarContent = hasPermission(PermissionEnum.CREATE_PRODUCTS) && (
        <Button
          variant="contained"
          onClick={() => setIsAddDialogOpen(true)}
        >
          Tambah
        </Button>
      );

  return (
    <PageContainer maxWidth="xl" breadcrumbs={[]} slotProps={{ header: { slotProps: { toolbar: { children: toolbarContent } } } }}>
      <Stack spacing={3}>
        <DataGrid
          loading={loading}
          rows={salesOrderDefaultGeneralProductVariants}
          getRowHeight={() => "auto"}
          columns={[
            {
              field: "productVariant.sku",
              headerName: "SKU",
              flex: 1,
              sortable: false,
              valueGetter: (_, { productVariant: { sku } }) => sku,
            },
            {
              field: "productVariant.name",
              headerName: "Nama",
              flex: 1,
              sortable: false,
              valueGetter: (_, { productVariant: { name } }) => name,
            },
            {
              field: "actions",
              type: "actions",
              headerName: "Aksi",
              getActions: ({ id }) => [
                <IconButton
                  key="delete"
                  onClick={() => setDeleteConfirmationDialogOpen(id)}
                  size="small"
                >
                  <DeleteIcon />
                </IconButton>,
              ],
            },
          ]}
          disableRowSelectionOnClick
          hideFooter
        />
        {isAddDialogOpen && (
          <AddSalesOrderDefaultGeneralProductVariantFormDialog
            onClose={() => setIsAddDialogOpen(false)}
            onSubmitted={loadSalesOrderDefaultGeneralProductVariants}
          />
        )}
        {deleteConfirmationDialogOpen && (
          <DeleteConfirmationDialog
            id={deleteConfirmationDialogOpen}
            onClose={() => setDeleteConfirmationDialogOpen(null)}
            onSubmitted={loadSalesOrderDefaultGeneralProductVariants}
          />
        )}
      </Stack>
    </PageContainer>
  );
};
